import React, { useState } from 'react';
import clsx from 'clsx';
import ReactMde from 'react-mde';
import 'react-mde/lib/styles/css/react-mde-all.css';
import TrimmedMarkdownRender from './TrimmedMarkdownRender';

const MarkdownEditor = ({
  autoFocus,
  className,
  disabled,
  maxChars = 100000,
  maxEditorHeight,
  maxLines = 0,
  minPreviewHeight,
  onChange,
  suffix = 'markdown.partial.suffix',
  tools = [['bold', 'italic'], ['ordered-list', 'unordered-list'], ['link', 'quote']],
  value,
  withMessage,
}) => {
  const [view, setView] = useState('write');

  return (
    <ReactMde
      readOnly={disabled}
      textAreaProps={{ autoFocus }}
      toolbarCommands={tools}
      value={value}
      minPreviewHeight={minPreviewHeight}
      maxEditorHeight={maxEditorHeight}
      onChange={onChange}
      selectedTab={view}
      onTabChange={setView}
      className={clsx('aridhia-markdown-editor', className)}
      generateMarkdownPreview={(markdown) => Promise.resolve(
        <TrimmedMarkdownRender
          className={className}
          maxChars={maxChars}
          maxLines={maxLines}
          suffix={suffix}
          text={markdown}
          withMessage={withMessage}
        />,
      )}
    />
  );
};

export default MarkdownEditor;
